import type { TFunction } from 'i18next';
import uniqBy from 'lodash/uniqBy';
import { Text } from '@usealloy/component-library';

import { withI18n } from '~/helpers/i18n';

import { generateBlockedActionsHash } from './helpers';
import { PartialExplanation } from './PartialExplanation';
import {
  ScrollboxContainer,
  StyledBanner,
  StyledList,
  StyledListContainer,
} from './PartialDetails.styles';


interface Props {
  evaluation: any;
  isJourneyApplicationPage?: boolean;
  t: TFunction;
}

const PartialDetailsUnwrapped = (props: Props) => {
  const {
    evaluation: {
      final_response: {
        summary,
        warnings: {
          blocked_actions: blockedActions,
        },
      },
    },
    isJourneyApplicationPage,
    t,
  } = props;

  const blockedActionsHash = generateBlockedActionsHash(blockedActions, summary, t);

  return (
    <StyledBanner
      borderColor="var(--cl-red-300)"
      open
      outline
      variant="error"
    >
      <StyledListContainer>
        <Text as="h3" lineHeight={5} size={3} weight={700}>
          {t('features.evaluations.results.partial.copy') as unknown as React.ReactNode}
        </Text>
        <ScrollboxContainer>
          <StyledList>
            {
              // NOTE: We use _.uniq here because one service failure may account
              // for multiple blocked actions but we don't want to show a bullet
              // point for every instance of said failure
              uniqBy(blockedActionsHash.blocking, 'text').map(blockedAction => (
                <li key={blockedAction.key}>
                  <Text as="span" lineHeight={5} size={2}>
                    {blockedAction.text}
                  </Text>
                </li>
              ))
            }
            {uniqBy(blockedActionsHash.blocked, 'text').map(blockedAction => (
              <li key={blockedAction.key}>
                <Text as="span" lineHeight={5} size={2}>
                  {blockedAction.text}
                </Text>
              </li>
            ))}
          </StyledList>
        </ScrollboxContainer>
        <PartialExplanation
          blockedActions={blockedActions}
          isJourneyApplicationPage={isJourneyApplicationPage}
          summary={summary}
          t={t}
        />
      </StyledListContainer>
    </StyledBanner>
  );
};

export const PartialDetails = withI18n({
  importPath: 'features/evaluations',
  translationKey: 'features.evaluations.results.partial',
})(PartialDetailsUnwrapped);
